__turbopack_context__.v({
  "address": "PickupLocationDetails-module__Ud68bG__address",
  "rootContainer": "PickupLocationDetails-module__Ud68bG__rootContainer",
  "rootContainerLandscape": "PickupLocationDetails-module__Ud68bG__rootContainerLandscape",
  "storeContact": "PickupLocationDetails-module__Ud68bG__storeContact",
  "storeDetails": "PickupLocationDetails-module__Ud68bG__storeDetails",
  "storeHours": "PickupLocationDetails-module__Ud68bG__storeHours",
  "storeHoursLandscape": "PickupLocationDetails-module__Ud68bG__storeHoursLandscape" + " " + "PickupLocationDetails-module__Ud68bG__storeHours",
});
